import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';


export async function GetBM(gregDate) {
	const hDate = new HDate(gregDate);

	return new Promise((myResolve, myReject) => {
		myResolve(
			<div className='general'>
				<center className='shiur-title'><b>ברכה מעין שלוש</b></center>

				<p>
					בָּרוּךְ אַתָּה יְיָ, אֱלֹהֵינוּ מֶלֶךְ הָעוֹלָם, עַל<br />
					<small>על ה' מיני דגן:</small><br /> הַמִּחְיָה וְעַל הַכַּלְכָּלָה<br />
					<small>על היין:</small><br /> הַגֶּפֶן וְעַל פְּרִי הַגֶּפֶן<br />
					<small>על פירות משבעת המינים:</small><br /> הָעֵץ וְעַל פְּרִי הָעֵץ
				</p>

				<p>
					וְעַל תְּנוּבַת הַשָּׂדֶה וְעַל אֶרֶץ חֶמְדָּה טוֹבָה וּרְחָבָה שֶׁרָצִיתָ
					וְהִנְחַלְתָּ לַאֲבוֹתֵינוּ לֶאֱכוֹל מִפִּרְיָהּ וְלִשְׂבּוֹעַ מִטּוּבָהּ.
					רַחֶם נָא יְיָ אֱלֹהֵינוּ עַל יִשְׂרָאֵל עַמֶּךָ וְעַל יְרוּשָׁלַיִם עִירֶךָ 
					וְעַל צִיּוֹן מִשְׁכַּן כְּבוֹדֶךָ. וְעַל מִזְבְּחֶךָ. וְעַל הֵיכָלֶךָ.
					וּבְנֵה יְרוּשָׁלַיִם עִיר הַקּדֶשׁ בִּמְהֵרָה בְיָמֵינוּ. וְהַעֲלֵנוּ לְתוֹכָהּ.
					וְשַׂמְּחֵנוּ בָהּ וּנְבָרֶכְךָ בִּקְדֻשָּׁה וּבְטָהֳרָה.
				</p>
			
				{ (HebDateUtil.IsRoshChodesh(hDate)) && <>וְזָכְרֵנוּ לְטוֹבָה בְּיוֹם ראשׁ הַחֹדֶשׁ הַזֶּה.</> }
				{ (HebDateUtil.IsPesach(hDate)) && <>וְזָכְרֵנוּ לְטוֹבָה בְּיוֹם חַג הַמַּצּוֹת הַזֶּה.</> }
				{ (HebDateUtil.IsSukkot(hDate)) && <>וְזָכְרֵנוּ לְטוֹבָה בְּיוֹם חַג הַסֻּכּוֹת הַזֶּה.</> }

				<p>כִּי אַתָּה יְיָ טוֹב וּמֵטִיב לַכּל וְנוֹדֶה לְךָ עַל הָאָרֶץ וְעַל</p>

				<p>
					<small>על ה' מיני דגן:</small><br /> הַמִּחְיָה. בָּרוּךְ אַתָּה יְיָ, עַל הָאָרֶץ וְעַל הַמִּחְיָה:<br />
					<small>על היין:</small><br /> פְּרִי הַגָּפֶן. בָּרוּךְ אַתָּה יְיָ, עַל הָאָרֶץ וְעַל פְּרִי הַגָּפֶן:<br />
					<small>על פירות משבעת המינים:</small><br /> הַפֵּרוֹת. בָּרוּךְ אַתָּה יְיָ, עַל הָאָרֶץ וְעַל הַפֵּרוֹת:
				</p>

        		<p>
					בָּרוּךְ אַתָּה ה' אֱלֹהֵינוּ מֶלֶךְ הָעוֹלָם, בּוֹרֵא נְפָשׁוֹת רַבּוֹת
					וְחֶסְרוֹנָן עַל כֹּל מַה שֶּׁבָּרָאתָ לְהַחֲיוֹת בָּהֶם נֶפֶשׁ כָּל חָי,
					בָּרוּךְ חֵי הָעוֹלָמִים:
				</p>
			</div>
		);
	});
};